// eslint-disable-next-line no-use-before-define
import React, { ReactElement } from 'react';
import { BarChart } from './bar-chart';
import { BarChartProps } from '../types';

export const BarChartHorizontal = <Datum = unknown,>({
	xScaleType = 'linear',
	yScaleType = 'band',
	...rest
}: Omit<BarChartProps<Datum>, 'orientation'>): ReactElement => {
	return <BarChart<Datum> xScaleType={xScaleType} yScaleType={yScaleType} {...rest} orientation="horizontal" />;
};
